import dayjs from 'dayjs';

import getDateTime from '@/utils/getDateTime.utils';

export const formatAlertRuleDetailsValue = (value: boolean | string) => {
  switch (true) {
    case typeof value === 'boolean':
      return value ? 'Enabled' : 'Disabled';
    case dayjs(value as string).isValid():
      return getDateTime(value as string);
    default:
      return value;
  }
};

export default formatAlertRuleDetailsValue;
